import { render, staticRenderFns } from "./top-lang.vue?vue&type=template&id=7041c164&scoped=true&"
import script from "./top-lang.vue?vue&type=script&lang=js&"
export * from "./top-lang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7041c164",
  null
  
)

export default component.exports